'use strict';

const handler = (originMapping, routes) => {
    const nonSensitiveOrigins = Object.entries(originMapping)
        .filter(([_, originConfig]) => {
        return !originConfig.sensitive;
    })
        .map(([originName]) => originName);
    const nonSensitiveRoutes = routes.filter((route) => !route.sensitive);
    return () => {
        return new Response(JSON.stringify({
            origins: nonSensitiveOrigins,
            routes: nonSensitiveRoutes,
        }), {
            headers: { "content-type": "application/json" },
        });
    };
};

exports.handler = handler;
//# sourceMappingURL=config.cjs.map
